import script from "./RcPrivateRegistry.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcPrivateRegistry.vue?vue&type=script&setup=true&lang=ts"

import "./RcPrivateRegistry.vue?vue&type=style&index=0&id=ca51bb0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca51bb0a"]])

export default __exports__